import {get} from "lodash";
import {Language} from "data/enums";
import {logos, pickEmLogos} from "data/constants";

export const getLogo = (lang: string) => get(logos, lang, logos[Language.English]);

export const getPickEmLogo = (lang: string) =>
	get(pickEmLogos, lang, pickEmLogos[Language.English]);

export const getHeaderLogo = (lang: string) => get(logos, lang, logos[Language.English]);
